import React from 'react';
import { Helmet } from 'react-helmet-async';

interface PerformanceTagsProps {
  preloadFonts?: string[];
  preconnectDomains?: string[];
  dnsPrefetch?: string[];
  criticalCSS?: string;
}

const PerformanceTags: React.FC<PerformanceTagsProps> = ({
  preloadFonts = [
    'https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZ9hiA.woff2'
  ],
  preconnectDomains = [
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com',
    'https://www.google-analytics.com',
    'https://www.googletagmanager.com'
  ],
  dnsPrefetch = [
    '//fonts.googleapis.com',
    '//fonts.gstatic.com',
    '//www.google-analytics.com',
    '//www.googletagmanager.com',
    '//cdn.jsdelivr.net'
  ],
  criticalCSS
}) => {
  return (
    <Helmet>
      {/* Preconnect to required origins */}
      {preconnectDomains.map((domain) => (
        <link
          key={domain}
          rel="preconnect"
          href={domain}
          crossOrigin={domain.includes('fonts') ? 'anonymous' : undefined}
        />
      ))}
      
      {/* DNS prefetch for performance */}
      {dnsPrefetch.map((domain) => (
        <link key={domain} rel="dns-prefetch" href={domain} />
      ))}
      
      {/* Preload critical fonts */}
      {preloadFonts.map((font, index) => (
        <link
          key={index}
          rel="preload"
          as="font"
          type="font/woff2"
          href={font}
          crossOrigin="anonymous"
        />
      ))}
      
      {/* Resource hints for better performance */}
      <link rel="preload" as="script" href="/main.js" />
      <link rel="modulepreload" href="/main.js" />
      
      {/* Critical CSS if provided */}
      {criticalCSS && (
        <style dangerouslySetInnerHTML={{ __html: criticalCSS }} />
      )}
      
      {/* Performance optimizations */}
      <meta httpEquiv="x-dns-prefetch-control" content="on" />
      <meta name="format-detection" content="telephone=no" />
      
      {/* PWA performance hints */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      
      {/* Prefetch next page resources */}
      <link rel="prefetch" href="/find" />
      <link rel="prefetch" href="/specialties" />
      
      {/* Optimization for Core Web Vitals */}
      <link rel="preload" as="image" href="/hero-image.webp" />
    </Helmet>
  );
};

export default PerformanceTags;